export const PROCESSOR_LABEL = 'Processesor';
export const MERCHANT_LABEL = 'Merchant';
export const SUB_MERCHANT_LABEL = 'Sub Merchant';

export const getRoleDisplayLabel = (role?: string | null): string => {
  if (!role) {
    return '';
  }

  switch (role) {
    case 'SuperAgent':
    case 'superAgent':
      return MERCHANT_LABEL;
    case 'Agent':
    case 'agent':
      return SUB_MERCHANT_LABEL;
    default:
      return role;
  }
};

export const getPayoutPartyDisplayLabel = (party?: string | null): string => {
  if (!party) {
    return '';
  }

  switch (party) {
    case 'Company':
    case 'Admin':
      return PROCESSOR_LABEL;
    case 'SuperAgent':
      return MERCHANT_LABEL;
    case 'Agent':
      return SUB_MERCHANT_LABEL;
    default:
      return party;
  }
};

export const getFeeDisplayLabel = (feeType?: string | null): string => {
  if (!feeType) {
    return '';
  }

  switch (feeType) {
    case 'SuperAgent':
    case 'superAgent':
      return MERCHANT_LABEL;
    case 'Agent':
    case 'agent':
      return SUB_MERCHANT_LABEL;
    default:
      return feeType;
  }
};
